import script from "./EditPostModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPostModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditPostModal.vue?vue&type=style&index=0&id=50335a1f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50335a1f"]])

export default __exports__